module.exports = __webpack_public_path__ + "static/how_to_become_a_ui_designer-10820dd38d3b23148e1445a7851ed076.png";